// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"cc4ce9ba","239":"e5c7ca67","455":"15231799"}[chunkId] + ".chunk.js";
};